import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton, Stack } from '@mui/material';

const EMPTY_CATALOG_ENTRY_LIST_EMS_NAME = 'DPSV2_CatalogEntryList_Empty';

export const CatalogEntryListEmptyContentRecommendation = () => (
	<ContentRecommendation
		id={EMPTY_CATALOG_ENTRY_LIST_EMS_NAME}
		properties={{
			emsName: EMPTY_CATALOG_ENTRY_LIST_EMS_NAME,
		}}
		loadingElement={
			<Stack>
				<Skeleton variant="rectangular" height={100} />
				<Skeleton variant="rectangular" height={100} />
				<Skeleton variant="rectangular" height={100} />
			</Stack>
		}
	/>
);
